module.exports = __webpack_public_path__ + "img/jdProps.a553f065.svg";